import { WidgetsApi } from '@/plugins/widgetsApi/'
import lodash from 'lodash'
import underscore from 'underscore'

export class JsActionApi {
  get EdsApi() {
    return this.#getEdsApi()
  }
  
  get QrCodeApi() {
    return this.#getQrCodeApi()
  }

  #getEdsApi = null
  #getQrCodeApi = null

  constructor(dependencies) {
    const { 
      store,
      GraphqQlApi, 
      Moment, 
      MomentDuration,
      SignalRApi, 
      NotificationApi, 
      ProcessingApi, 
      getEdsApi, 
      getQrCodeApi,
      axios, 
      RouterCore, 
      DataSourceCore,
      $t,
      $microflowRunner,
      $eds
    } = dependencies
    this.#getEdsApi = getEdsApi
    this.#getQrCodeApi = getQrCodeApi

    this.WidgetsApi = new WidgetsApi()
    this.store = store
    this.GraphqQlApi = GraphqQlApi
    this.$t = $t
    this.$eds = $eds
    this.Moment = Moment
    this.MomentDuration = MomentDuration
    this.SignalRApi = SignalRApi
    this.NotificationApi = NotificationApi
    this.ProcessingApi = ProcessingApi
    this.Axios = axios
    this.RouterCore = RouterCore
    this.DataSourceCore = DataSourceCore
    this.MicroflowApi = this.$microflowRunner = $microflowRunner
    this.Lodash = lodash
    this.Underscore = underscore
    this.JsActionApi = function () {
      return new JsActionApi(dependencies)
    }
  }
  async call(id, parameters) {
    let JSActions = this.store.state.appRunner.model.Modules.DefaultModuleImpl.JSActions
    if (!JSActions || JSActions.length == 0) {
      return null
    }
    const currentJsAction = JSActions.find(el => el.$ID == id)
    if (!currentJsAction) {
      console.error(`JSAction with id ${id} not found`)
      return null
    }

    try {
      let callJsActionMethod = new Function('parameters', currentJsAction.Text)
      return callJsActionMethod.call(this, parameters)
    } catch (e) {
      console.error(`In JSAction ${id} detected syntactic error`)
      return null
    }
  }
}